import React from 'react'
import UiInputText from "../components/Form/UiInputText";
import UiInputDate from "../components/Form/UiInputDate";
import Form from "../components/Form/Form";
import {useForm, FormProvider} from "react-hook-form";
import FormContainer from '../components/Form/FormContainer';
import Button from 'react-bootstrap/Button';
import UiInputSuggest from "../components/Form/UiInputSuggest";
import UiInputList from "../components/Form/UiInputList";
import UiInputMoney from "../components/Form/UiInputMoney";

export default function RecebimentoForm(props: any){
    const today = new Date().toISOString().split('T')[0];
    const methods = useForm({
        defaultValues: props.data || { origem: 'pix', data: today }
    });
    const { handleSubmit } = methods;

    const origemList = [
        { id: 'pix', title: 'PIX' },
        { id: 'dinheiro', title: 'Dinheiro' },
        { id: 'boleto', title: 'Boleto' },
        { id: 'transferencia', title: 'Transferência' },
        { id: 'financiamento', title: 'Financiamento' },
        { id: 'cartao', title: 'Cartão' },
        { id: 'cheque', title: 'Cheque' },
        { id: 'outro', title: 'Outro' },
    ];

    return (
        <FormContainer size="lg" show={true} onHide={props.triggerClose}>
            <FormProvider {...methods}>
                <Form onSubmit={handleSubmit(props.triggerSubmit)} methods={methods}>
                    <FormContainer.Header onClose={props.triggerClose}>
                        <h5>{props.data?.id ? 'Editar Recebimento' : 'Novo Recebimento'}</h5>
                    </FormContainer.Header>
                    <FormContainer.Body>
                        <div className="row">
                            <div className="col-12">
                                <fieldset>
                                    <legend>Vinculação</legend>
                                    <div className="row">
                                        <UiInputSuggest size={6} router="contrato" idField="id" titleField="cli_nome" name="contrato" label="Contrato" required />
                                        <UiInputSuggest size={6} router="contaFinanceira" idField="id" titleField="nome" name="contaFinanceira" label="Conta Financeira" required />
                                    </div>
                                </fieldset>
                            </div>
                            <div className="col-12">
                                <fieldset>
                                    <legend>Dados do Recebimento</legend>
                                    <div className="row">
                                        <UiInputDate size={3} name="data" label="Data" dateFormat="dd/mm/yy" />
                                        <UiInputMoney size={3} name="valor" label="Valor" required />
                                        <UiInputList size={3} name="origem" list={origemList} idField="id" titleField="title" label="Origem" required />
                                        <UiInputText size={3} name="referencia" label="Referência" />
                                        <UiInputText size={12} name="descricao" label="Descrição" />
                                        <UiInputText size={12} name="observacoes" label="Observações" />
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </FormContainer.Body>
                    <FormContainer.Footer>
                        <Button variant="secondary" onClick={props.triggerClose}>Fechar</Button>
                        <Button variant="primary" type="submit">Salvar</Button>
                    </FormContainer.Footer>
                </Form>
            </FormProvider>
        </FormContainer>
    )
}
